<template>
    <app-page-content>
        <app-sub-title text="Gestión interna del cliente"></app-sub-title>
        <b-row>
            <b-col cols="12" md="5" lg="4">
                <app-autocomplete
                    :get-object="false"
                    v-model="clientId"
                    :items="clients"
                    @input="onClientSelected"
                />
            </b-col>
            <b-col cols="12" md="5" lg="4">
                <b-button
                    :disabled="!selectedClient"
                    class="btn-block"
                    variant="primary"
                    @click="createManagement"
                >
                    <i class="fa fa-plus"></i> Crear Gestión Interna del
                    cliente
                </b-button>
            </b-col>
        </b-row>
        <app-internal-management-filters @filter="onFilter" :types="types" />
        <app-internal-management-table
            :data="internalManagement"
            :onStartEditing="onStartEditing"
            :onStartDeleting="onStartDeleting"
            @change-page="onChangePage"
            @sort="onSort"
            @open-internal-management-files="internalFilesModal"
        />

        <!-- Inicio pop up's -->
        <app-pop-up
            size="large"
            :title="
                `Formulario de Gestión Interna en el cliente ${
                    !!selectedClient ? selectedClient.name : ''
                }`
            "
            id="internal-management-form"
            :onClose="cleanForm"
        >
            <div slot="body">
                <app-internal-management-form
                    ref="internal-management-form"
                    v-if="!!selectedClient"
                    :types="types"
                    :selected-client="selectedClient"
                    :selected-management="selectedManagement"
                    :on-save="onSaveInternalManagement"
                    :venues="venues"
                />
            </div>
            <div slot="buttons">
                <b-button
                    variant="confirm"
                    @click="$bus.$emit('internal-management-form.save')"
                >Guardar</b-button>
            </div>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="internal-management-remove">
            <div slot="body">
                <h2>¿Esta seguro que desea eliminar esta la gestión interna?</h2>
            </div>
            <div class="buttons" slot="buttons">
                <b-button variant="confirm" @click="deleting">Confirmar Eliminación</b-button>
            </div>
        </app-pop-up>

        <app-pop-up
            id="internal-management-files"
            size="large"
            title="Documentos de la gestion interna"
        >
            <template slot="body">
                <app-internal-management-files
                    :item="internalManagementItem"
                    ref="internalManagementFiles"
                ></app-internal-management-files>
            </template>
        </app-pop-up>
        <!-- Fin pop up's -->
    </app-page-content>
</template>
<script>
import InternalManagementTable from './InternalManagementTable/InternalManagementTable.vue'
import FormSelectInput from '../../../UI/Controls/Forms/FormSelectInput.vue'
import internalManagementRepository from '../../../../repositories/internalManagement.repository'
import InternalManagementForm from './InternalManagementForm/InternalManagementForm.vue'
import InternalManagementFilters from './InternalManagementFilters/InternalManagementFilters'
import InternalManagementFiles from './InternalManagementForm/InternalManagementFiles'
import { mapGetters } from 'vuex'

export default {
    components: {
        appInternalManagementTable: InternalManagementTable,
        appFormSelectInput: FormSelectInput,
        appInternalManagementForm: InternalManagementForm,
        appInternalManagementFilters: InternalManagementFilters,
        appInternalManagementFiles: InternalManagementFiles,
    },
    data() {
        return {
            internalManagement: {},
            types: [],
            clientId: '',
            page: 1,
            filters: {},
            selectedManagement: null,
            sort: {
                sortBy: 'created_at',
                sortDir: 'desc',
            },
            venues: [],
            internalManagementItem: [],
        }
    },
    computed: {
        ...mapGetters(['clients']),
        selectedClient() {
            if (!this.clientId) return null

            return this.clients.find(client => client.id === this.clientId)
        },
    },
    methods: {
        internalFilesModal(item) {
            this.internalManagementItem = item
            this.$bus.$emit('internal-management-files.open')
        },
        async onClientSelected(client) {
            const { data } = await repo.get('venues', { client })
            this.venues = data
        },
        loadInternalManagement() {
            const filters = {
                ...this.filters,
                ...this.sort,
            }
            const ir = { ...internalManagementRepository }
            ir.getManagementByClient(filters, this.page)
                .then(data => {
                    this.internalManagement = data
                })
                .catch(error =>
                    toastr.error(
                        'Ocurrió un error al cargar la gestión interna de los clientes'
                    )
                )
        },
        loadInternalManagementTypes() {
            const ir = { ...internalManagementRepository }
            ir.getTypes()
                .then(data => (this.types = data))
                .catch(error =>
                    toastr.error(
                        'Ocurrió un error al cargar los tipos de gestión interna'
                    )
                )
        },
        initialize() {
            this.load('clients')
            this.loadInternalManagement()
            this.loadInternalManagementTypes()
        },
        onStartEditing(item) {
            this.selectedManagement = Object.assign({}, item)
            this.clientId = item.client_id
            this.$bus.$emit('internal-management-form.open')
        },
        onStartDeleting(item) {
            this.selectedManagement = Object.assign({}, item)
            this.$bus.$emit('internal-management-remove.open')
        },
        deleting() {
            const ir = { ...internalManagementRepository }
            ir.deleteInternalManagement(this.selectedManagement.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.loadInternalManagement()
                        this.$bus.$emit('internal-management-remove.close')
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('Error al eliminar la gestión interna')
                })
        },
        onSaveInternalManagement(data) {
            // const index = this.internalManagement.data.findIndex(
            //     item => item.id === data.id
            // )
            // if (-1 === index) {
            //     this.internalManagement.data.push(data)
            // } else {
            //     this.internalManagement.data.splice(index, 1, data)
            // }
            this.loadInternalManagement()
            this.$bus.$emit('internal-management-form.close')
        },
        createManagement() {
            this.selectedManagement = null
            this.$bus.$emit('internal-management-form.open')
        },
        cleanForm() {
            this.$bus.$emit('internal-management-form.clean')
        },
        onChangePage(page) {
            this.page = page
            this.loadInternalManagement()
        },
        onFilter(filters) {
            this.filters = filters
            this.loadInternalManagement()
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadInternalManagement()
        },
    },
    created() {
        this.initialize()
    },
}
</script>
